import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowSetting = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.5 15.808V8.192L14.308 12L10.5 15.808Z" })
});
export default SvgArrowSetting;
